module.exports = __webpack_public_path__ + "img/ic_donate_light.339cbbb5.svg";